// extracted by mini-css-extract-plugin
module.exports = {"screenreaderonly":"_3ld2Va","clearfix":"_1c5Kcq","pagination":"_1T6g5k","ellipsis":"_1rcS8b","arrow":"Dex9O0","a11yText":"_2pTABf BeWlat","hideOnSmall":"_1BMpw5"};